import { render, staticRenderFns } from "./PaddingFullIcon.vue?vue&type=template&id=35739481&"
import script from "./PaddingFullIcon.vue?vue&type=script&lang=js&"
export * from "./PaddingFullIcon.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports